/**
 * ai-package-blocks.ts
 * Genereert de PER-PAKKET offertetekst-blokken: "Voornaamste kenmerken" (bullets)
 * en "Over het pakket" (verhalende alinea). Mark schrijft zelf de opening en
 * afsluiting; het "Over [goed doel]"-blok komt uit de blokkenbibliotheek (niet
 * verzonnen door de AI). Voedt zich met klant-uitgangspunten en huisstijl-voorbeelden.
 *
 * De pure prompt-opbouw + parsing staat in package-blocks-prompt.ts (testbaar zonder
 * Supabase). Dit bestand doet de netwerk-call.
 * Ontwerp: tenants/2bmade/docs/offerteteksten-feature-ontwerp.md
 */

import { aiComplete } from './ai-complete';
import { fetchPresentationExamples } from './api';
import {
  PACKAGE_BLOCKS_SYSTEM_PROMPT,
  buildPackageBlocksMessage,
  parsePackageBlocks,
} from './package-blocks-prompt';
import type { GeneratePackageBlocksInput, PackageBlocks } from './package-blocks-prompt';
import type { PresentationExample } from './types';

export type { GeneratePackageBlocksInput, PackageBlocks } from './package-blocks-prompt';

export async function generatePackageBlocks(
  input: GeneratePackageBlocksInput
): Promise<PackageBlocks> {
  let examples: PresentationExample[] = [];
  try {
    examples = await fetchPresentationExamples();
  } catch {
    examples = []; // voorbeelden zijn optioneel; zonder gaat de generatie gewoon door
  }

  const content = await aiComplete({
    messages: [
      { role: 'system', content: PACKAGE_BLOCKS_SYSTEM_PROMPT },
      { role: 'user', content: buildPackageBlocksMessage(input, examples) },
    ],
    json: true,
    temperature: 0.6,
    max_tokens: 1200,
  });

  return parsePackageBlocks(content);
}
